e360.service('participantsApi', [
   'apiHelper',
   function (apiHelper) {
      function filesOfType(type) {
         if (this.files) {
            return _.filter(this.files, function(f) {
               return f.mimeType.indexOf(type) >= 0;
            });
         }

         return [];
      }

      /**
       * Formats properties and adds extra business logic to participant object.
       */
      function decorateParticipant(data) {
         if (data.dateOfBirth !== null) {
            data.dateOfBirth = moment(data.dateOfBirth).toDate();
         }

         if (data.files) {
            _.each(data.files, function(f) {
               f.url = apiHelper.getApiUrl('media/' + f.id);
               if (f.private) {
                  f.url = apiHelper.getApiUrl('media/private/' + f.id);
               }
            });
         }

         data.filesOfType = filesOfType;

         return data;
      }

      return {
         get: function (id) {
            return apiHelper.get('participants/' + id).then(decorateParticipant);
         },
         update: function (participant) {
            return apiHelper.post('participants/' + participant.id, participant);
         },
         create: function (participant) {
            return apiHelper.post('participants', participant);
         },
         del: function (id) {
            var url = 'participants/';

            if (angular.isArray(id)) {
               url = url + 'bulk?ids=' + id.join('&ids=');
            } else {
               url = url + id;
            }

            return apiHelper.del(url);
         },
         list: function (params) {
            return apiHelper.get('participants', params);
         }
      };
   }
]);
